import { Component } from '@angular/core';

@Component({
  templateUrl: './onboarding.page.html',
})
/**
 * Onboarding page
 */
export class OnboardingPage {}
